import { EChatbotActionTypes, TToggleChatbotPeriodicityMenu } from './types';
import { IChatbotActionButtons } from '../../services/fetchChatbotActionButtons';
import { EPeriodicity } from '../../services/fetchChatbotMessages';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setChatbotRowVersion = actionGenerator<EChatbotActionTypes.SetChatbotRowVersion, number>(
  EChatbotActionTypes.SetChatbotRowVersion,
);

export const setChatbotUnreadMessagesCount = actionGenerator<EChatbotActionTypes.SetChatbotUnreadMessagesCount, number>(
  EChatbotActionTypes.SetChatbotUnreadMessagesCount,
);
export const setChatbotPollingIntervalId = actionGenerator<
  EChatbotActionTypes.SetChatbotPollingIntervalId,
  number | null
>(EChatbotActionTypes.SetChatbotPollingIntervalId);

export const setChatbotPeriodicity = actionGenerator<EChatbotActionTypes.SetChatbotPeriodicity, EPeriodicity>(
  EChatbotActionTypes.SetChatbotPeriodicity,
);

export const toggleChatbotPeriodicityMenu: (value?: boolean) => TToggleChatbotPeriodicityMenu = actionGenerator<
  EChatbotActionTypes.ToggleChatbotPeriodicityMenu,
  boolean
>(EChatbotActionTypes.ToggleChatbotPeriodicityMenu);

export const setChatbotHasPollAnswers = actionGenerator<EChatbotActionTypes.SetChatbotHasPollAnswers, boolean>(
  EChatbotActionTypes.SetChatbotHasPollAnswers,
);

export const setChatbotActionButtons = actionGenerator<
  EChatbotActionTypes.SetChatbotActionButtons,
  IChatbotActionButtons
>(EChatbotActionTypes.SetChatbotActionButtons);

export const setChatbotIsTyping = actionGenerator<EChatbotActionTypes.SetChatbotIsTyping, boolean>(
  EChatbotActionTypes.SetChatbotIsTyping,
);

export const setChatbotMessageSending = actionGenerator<EChatbotActionTypes.SetChatbotMessageSending, boolean>(
  EChatbotActionTypes.SetChatbotMessageSending,
);

export const setChatbotIsOpenEventSent = actionGenerator<EChatbotActionTypes.SetChatbotIsOpenEventSent, boolean>(
  EChatbotActionTypes.SetChatbotIsOpenEventSent,
);
